export default __webpack_public_path__ + "static/media/Deceitful Gloves.bbfe7f43.jpg";